import { t } from '@lingui/core/macro'
import { useId } from 'react'
import styled, { css, keyframes } from 'styled-components'

const searchingBounce = keyframes`
  0%, 100% { transform: translateY(0) rotate(0deg); }
  35% { transform: translateY(-4px) rotate(-6deg); }
  60% { transform: translateY(0) rotate(0deg); }
  78% { transform: translateY(-1.5px) rotate(3deg); }
`
const Icon = styled.svg<{ $loading: boolean }>`
  pointer-events: none;
  overflow: visible;
  color: var(--color-zinc-700);
  [data-part='magnifier'] {
    transform-origin: 16px 16px;
    ${({ $loading }) =>
      $loading &&
      css`
        animation: ${searchingBounce} 1.8s ease-in-out infinite;
      `}
  }
  @media (prefers-reduced-motion: reduce) {
    [data-part='magnifier'] {
      animation: none;
    }
  }
`

export function CrossReferenceMarker({
  loading,
  x,
  y,
  size = 28 / 3,
}: {
  loading: boolean
  x?: number
  y?: number
  size?: number
}) {
  const id = useId()
  const backing = `${id}-backing`
  return (
    <Icon
      x={x}
      y={y}
      width={size}
      height={size}
      viewBox='0 0 32 32'
      $loading={loading}
      data-testid='cross-reference-marker'
      data-loading={loading}
      role='img'
      aria-label={
        loading ? t`Searching this location` : t`Cross-reference location`
      }>
      <defs>
        <radialGradient id={backing}>
          <stop offset='0' stopColor='var(--info)' stopOpacity='.85' />
          <stop offset='.4' stopColor='var(--info)' stopOpacity='.7' />
          <stop offset='.75' stopColor='var(--info)' stopOpacity='.35' />
          <stop offset='1' stopColor='var(--info)' stopOpacity='0' />
        </radialGradient>
      </defs>
      <circle cx='16' cy='16' r='15' fill={`url(#${backing})`} />
      <g
        data-part='magnifier'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'>
        <circle cx='14' cy='14' r='6' />
        <path d='M18.5 18.5 24 24' />
      </g>
    </Icon>
  )
}
